import '../shared/types';

/**
 * @typedef {object} PlayerComparisonFilterState
 * @property {string[]} positions
 * @property {string[]} teams
 */
